export const propertyEndpoints = {
  accessible: () => '/mobile/properties',
};
